import * as React from 'react';
import { IQueryableRouteComponentProps } from 'easit--routing';
import { inject, observer } from 'mobx-react';
import { SimpleBarWrapper } from 'desktop--design-library';
import { ApplicationStore, ApplicationStoreKey } from '../../liveStores';
import { EventDetailRawContainer } from './eventDetailRawContainer';
import { FooterContainer } from '../footer/footerContainer';
import { Instance } from 'mobx-state-tree';
import { evalFooterVisibility } from 'eTip--common';

export interface IEventDetailRouteParams {
    eventId?: string; // must be string, empty open first detail
}

export interface IEventDetailRouteProps extends IQueryableRouteComponentProps<IEventDetailRouteParams, { ls?: string; }> {
    applicationStore?: Instance<typeof ApplicationStore>;
}

export interface IEventDetailRouteState {
    active: number[];
}

export interface IRateSelectionEventParam {
    id: number;
    active: boolean;
}

@inject(ApplicationStoreKey)
@observer
export class EventDetailRouteContainer extends React.Component<IEventDetailRouteProps, IEventDetailRouteState> {

    constructor(props: IEventDetailRouteProps) {
        super(props);
        this.state = { //TODOHL necessary?
            active: []
        };
    }

    componentWillMount() {
        this.props.applicationStore.setCanShowLeftColumn(true);
    }

    /*routeParams(props: IEventDetailRouteProps) {
        return createEventDetailParams(props.match.params, props.location.query);
    }*/

    getFirstEventId() {
        if (this.props.applicationStore.events.favoriteCats.length > 0) {
            if (this.props.applicationStore.events.favoriteCats[0].events.length > 0) {
                return this.props.applicationStore.events.favoriteCats[0].events[0].id;
            }
        }
        if (this.props.applicationStore.events.categories.length > 0) {
            if (this.props.applicationStore.events.categories[0].events.length > 0) {
                return this.props.applicationStore.events.categories[0].events[0].id;
            }
        }
        return -1;
    }

    render() {
        let eventId = this.props.match.params.eventId ? Number(this.props.match.params.eventId) : this.getFirstEventId();
        let hasMatchTracker = this.props.applicationStore.events.eventsWithMatchTracker.has(eventId);
        return (
            <SimpleBarWrapper className="h-100" forceVisible={true} scrollToTop>
                <EventDetailRawContainer
                    eventId={eventId}
                    store={this.props.applicationStore.eventDetail}
                    ticketWrapper={this.props.applicationStore.ticketWrapper}
                    canShowInTabs={this.props.applicationStore.settingsProvider.canShowLiveEventDetailGroupTabs}
                    canShowRemove={false}
                    isMatchTracker={hasMatchTracker}
                    matchTrackerClick={hasMatchTracker ? () => { this.props.applicationStore.events.rightSideStreamWrapper.open(this.props.applicationStore.events.eventsWithMatchTracker.get(eventId)) } : null}
                    canOpenLiveStreamAfterLoad={this.props.location.query.ls === "1"}
                    isLiveStreamAllowed={true}
                    isMatchTrackerAllowed={true}
                    isDetailInList={false}
                    canClearStoreOnUmount={true}
                />
                <FooterContainer canShow={evalFooterVisibility(this.props.applicationStore.eventDetail.state)} />
            </SimpleBarWrapper >
        )
    }

    componentWillUnmount() {
        this.props.applicationStore.eventDetail.clean();
    }
}
